import { useMemo } from 'react';
import { SWRConfiguration } from 'swr';
import { ILookup, ILookupItem } from '../../api/dtos';
import usePersonnel from '../data/usePersonnel';

export const usePersonnelLookup = (propertyName: string, roles?: number[], institutionCode?: string, configuration?: SWRConfiguration) => {
    const output = usePersonnel(roles, institutionCode, configuration);

    const modifiedOutput = useMemo(() => {
        const lookupItems: ILookupItem[] = output.data ?
            Object.keys(output.data).map((key) => {
                return {
                    id: output.data![key as any].id,
                    value: output.data![key as any].name ?? ''
                }
            }) :
            [];
    
        const lookups: ILookup = {
            propertyName: propertyName,
            items: lookupItems
        };

        return {
            ...output,
            data: lookups
        }
    }, [output, propertyName])

    return modifiedOutput;
};

export default usePersonnelLookup;